// ======================================================================
// File Name       : EnterpriseEditForm
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { Col, Form } from 'react-bootstrap';
import { connect } from 'react-redux';
import { Field, reduxForm, submit } from 'redux-form';
import * as enterpriseActions from '../../actions/EnterpriseAction';
import { Category, Item } from '../../components/Detail';
import { ValidationField } from '../../components/formControl/FormField';
import { DEFAULT_DATE_FORMAT, LO_SUPER_USER, MAX_SMALL_INT, MODE, USAGE_SETTING } from '../../constants';
import { ENTERPRISE_LAYER_L0, ENTERPRISE_LAYER_L1, NEW_PRICE_PLAN_RESERVATION, PRICE_PLAN, BILLING_SYSTEM_REGISTER_FLAG_STATUS, CREDIT_CHECKED_FLAG_STATUS, PAYMENT_TYPE } from '../../constants/EnterpriseConstants';
import * as MessageTemplate from '../../constants/MessageTemplate';
import {MSG_CREDIT_CHECK_ENTERPRISE, MSG_MANUAL_PASSWORD_SETTING_FLAG_CONTENT, MSG_MANUAL_PASSWORD_SETTING_FLAG_TITLE} from '../../constants/MessageTemplate';
import { SELECT_BOX_DATA } from '../../constants/SelectBoxData';
import * as utils from '../../utils';
import { getBillingSystemRegisterFlagLabel, getBillingSystemTargetLabel, getEnterpriseDeleteFlagLabel, getLiveInititalCostStatus } from '../../utils/EnterPriseUtils';
import * as validators from '../../validators';
import DateTimeWithValidate from '../DateTimeWithValidate';
import { validNumberRange } from '../../utils/ValidateUtils';
import DialogConfirm from '../../components/DialogConfirm';

class EnterpriseEdit extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      useNewPlan: '',
      showCreditCheck: false,
      showManualPasswordSettingModal: false
    };
    this.validateSmallInt = this.validateSmallInt.bind(this);
    this.handleOptionChange = this.handleOptionChange.bind(this);
    this.onCancelManualPasswordDialog = this.onCancelManualPasswordDialog.bind(this);
  }
  validateSmallInt(value) {
    if (value) {
      const regex = /^[0-9]*$/;
      if (!regex.test(value)) {
        return MessageTemplate.MSG_NUMERIC_INVALID;
      } else if (!validNumberRange(value, 0, MAX_SMALL_INT)) {
        return MessageTemplate.W_MAX_NUMBER.replace('{1}', MAX_SMALL_INT);
      }
    }
    return undefined;
  }

  handleOptionChange(event) {
    const { dispatch, editingEnterprise } = this.props;
    const usageSettingInfo = editingEnterprise.usageSettingInfo;
    if (event.target.name === 'usageSettingInfo.usageSettingVideo') {
      usageSettingInfo.usageSettingVideo = parseInt(event.target.value, 10);
      if (usageSettingInfo.usageSettingVideo === USAGE_SETTING.UN_USE) {
        this.props.change('unitPriceSettingInfo.unitPriceSettingVideoStorage', 0);
        this.props.change('unitPriceSettingInfo.unitPriceSettingVideoFlowRate', 0);
      }
    }
    
    this.props.change('unitPriceSettingInfo.unitPriceSettingLiveUsageRate', 0); //STEP12.1.0 TAS-16386

    if (event.target.name === 'usageSettingInfo.pricePlan') {
      const selectedPlan = parseInt(event.target.value, 10);
      usageSettingInfo.pricePlan = selectedPlan;
      this.setState({ useNewPlan: selectedPlan === PRICE_PLAN.NEW });
    }
    {/* sprint_20230522_tma START */}
    if (
      editingEnterprise.billingSystemRegisterFlag ==
        BILLING_SYSTEM_REGISTER_FLAG_STATUS.PENDING_REGISTERED ||
      editingEnterprise.billingSystemRegisterFlag ==
        BILLING_SYSTEM_REGISTER_FLAG_STATUS.REGISTERED
    ) {
      if (
        event.target.name === "creditCheckedFlag" &&
        event.target.value == CREDIT_CHECKED_FLAG_STATUS.PROBLEM
      ) {
        this.setState({ showCreditCheck: true });
      }
    }
    {/* sprint_20230522_tma END */}
    // STEP12.0.0 TAS-18710 START
    if (event.target.name === 'manualPasswordSettingFlag' &&
      event.target.value == 'true') {
        this.setState({ showManualPasswordSettingModal: true });
    }
    // STEP12.0.0 TAS-18710 END

    dispatch(enterpriseActions.updateUsageSetingInfo(usageSettingInfo));
    this.setState({ change: true });
  }

  // STEP12.0.0 TAS-18710 START
  onCancelManualPasswordDialog() {
    this.setState({ showManualPasswordSettingModal: false });
    this.props.change('manualPasswordSettingFlag', false);
  }
  // STEP12.0.0 TAS-18710 END

  render() {
    const props = this.props;
    const { editingEnterprise, rootFlag, isEditLoggedInEnterprise, isEnterpriseNotChild, enterpriseCdLogin } = props;
    const { displayUserType } = props.userInfo;
    const { usageSettingInfo } = props.initialValues;
    const { handleSubmit, handleTimeChange } = props;
    const editMode = props.editMode ? props.editMode === MODE.EDIT_MODE : false;
    const isSupperUserL0 = [LO_SUPER_USER].indexOf(displayUserType) > -1;
    const usageSettingInfoEdit = props && props.editingEnterprise && props.editingEnterprise.usageSettingInfo;
    const isSettingPricePlanUpdateReservedFlag = usageSettingInfoEdit?.pricePlanUpdateReservedFlag === undefined ? false : usageSettingInfoEdit.pricePlanUpdateReservedFlag; // Step 12.0.0TAS-18710
    const isUsingNewPlan = usageSettingInfoEdit?.pricePlan === undefined ? true : usageSettingInfoEdit.pricePlan === PRICE_PLAN.NEW; // Step 12.0.0TAS-18710
    const orgPricePlan = props.orgPricePlan;
    let isEnterpriseLayerL1 = null;
    let enterpriseNameToShow = '';
    let enterpriseCdToShow = '';
    let isShowNewPlanCombobox = false;
    let isShowUsageSetting = false;
    let isShowTimeRateText = false;
    let isDisableUpdateUnitPrice = false; // #7182
    // sprint_20230403 #4 START
    let enterpriseDeleteFlag = '';
    let billingSystemTarget = '';
    let billingSystemRegisterFlag = '';
    let enterpriseStartDate = '';
    let liveInitialcostStatus = '';
    // sprint_20230403 #4 END
    // sprint_20230605_tma START
    let paymentType = '';
    // sprint_20230605_tma END
    // STEP 10.0.0 START
    const isShowContractorInfo = isSupperUserL0 || rootFlag;
    // STEP 10.0.0 END
    // STEP12.0.0 TAS-18710 START
    let manualPasswordSettingFlag = '';
    // STEP12.0.0 TAS-18710 END
    // STEP13.0.0 TAS-21617 START
    const isEditSameEnterprise = enterpriseCdLogin === editingEnterprise.enterpriseCd;
    // STEP13.0.0 TAS-21617 END

    if (editMode) {
      enterpriseNameToShow = props && props.editingEnterprise ? props.editingEnterprise.enterpriseName || '' : '';
      enterpriseCdToShow = props && props.editingEnterprise ? props.editingEnterprise.enterpriseCd || '' : '';
    }

    if (isSupperUserL0) {
      if (editMode) {
        isEnterpriseLayerL1 = editingEnterprise.enterpriseLayer === ENTERPRISE_LAYER_L1;
        if (isEnterpriseLayerL1 && orgPricePlan !== PRICE_PLAN.NEW) { // 企業L1
          isShowUsageSetting = true;
          if (!isSettingPricePlanUpdateReservedFlag) {
            isShowNewPlanCombobox = true;
          }
        } else { // 企業L2以下
          isShowNewPlanCombobox = false;
          isShowUsageSetting = orgPricePlan === PRICE_PLAN.OLD;
        }

        // Check show ライブオプション利用料時間 in edit mode
        // #7182 START
        isShowTimeRateText = orgPricePlan === PRICE_PLAN.NEW;

        // #7198 START
        isDisableUpdateUnitPrice =
          (orgPricePlan === PRICE_PLAN.OLD && (this.state.useNewPlan || isUsingNewPlan))
          || (!isShowNewPlanCombobox && isEnterpriseLayerL1 && isSettingPricePlanUpdateReservedFlag);
        // #7198 END
        // #7182 END

        // sprint_20230403 #4 START
        enterpriseDeleteFlag = editingEnterprise.enterpriseDeleteFlag;
        billingSystemTarget = editingEnterprise.billingSystemTarget;
        billingSystemRegisterFlag = editingEnterprise.billingSystemRegisterFlag;
        enterpriseStartDate = editingEnterprise.enterpriseStartDate;
        liveInitialcostStatus = editingEnterprise.liveInitialcostStatus;
        // sprint_20230403 #4 END
        // STEP12.0.0 TAS-18710 START
        if (rootFlag) {
          manualPasswordSettingFlag = editingEnterprise.manualPasswordSettingFlag;
        }
        // STEP12.0.0 TAS-18710 END
      } else { // 新規登録
        const { parentEnterpriseInfo } = editingEnterprise;
        const { parentEnterpriseLayer, parentPricePlan, parentPricePlanUpdateReservedFlag } = parentEnterpriseInfo;
        isEnterpriseLayerL1 = parentEnterpriseLayer === ENTERPRISE_LAYER_L0;
        if (isEnterpriseLayerL1) { // 企業L1
          isShowNewPlanCombobox = true;
          isShowUsageSetting = !isUsingNewPlan;
        } else { // 企業L2以下
          isShowNewPlanCombobox = false;
          isShowUsageSetting = parentPricePlan === PRICE_PLAN.OLD;
        }

        //  Check show ライブオプション利用料時間 in new mode
        // #7182 START
        if (isEnterpriseLayerL1) {
          isShowTimeRateText = isUsingNewPlan;
        } else {
          isShowTimeRateText = parentPricePlan === PRICE_PLAN.NEW;
        }
        // #7182 END
      }
    }

    // Step 12.0.0 TAS-18710 START
    if (isEnterpriseNotChild) {
      enterpriseStartDate = editingEnterprise.enterpriseStartDate;
    }
    // Step 12.0.0 TAS-18710 END

    // sprint_20230403 #4 START
    this.refsToValidate = [];
    // sprint_20230403 #4 END

    return (
      <Form onSubmit={handleSubmit} className='form-horizontal'>
        {editMode && !isSupperUserL0 && !rootFlag ? (
          <Item name="企業名" value={enterpriseNameToShow} labelSize={4} valueSize={8} />
        ) : (
          <Field
            label="企業名"
            labelRequired
            name="enterpriseName"
            component={ValidationField}
            maxLength="256"
            validate={[validators.required]}
          />
        )}

        {editMode ? (
          <Item name="企業コード" value={enterpriseCdToShow} labelSize={4} valueSize={8}/>
        ) : (
          <Field
            label="企業コード"
            labelRequired
            name="enterpriseCd"
            component={ValidationField}
            maxLength="256"
            // sprint_20230403 #6 START
            validate={[validators.required, validators.alphaNumbericHyphen]}
            // sprint_20230403 #6 END
          />
        )}

        {/* sprint_20230403 #4 START */}
        {(isSupperUserL0 || isEnterpriseNotChild) && ( // Step 12.0.0TAS-18710
          <>
            {editMode && (
              <Form.Group className="form-info">
                <Col sm={4} as={Form.Label}>
                  利用開始日
                </Col>
                <Col sm={8} className="padding-left-right-15">
                  <DateTimeWithValidate
                    dateFormat={DEFAULT_DATE_FORMAT}
                    label="利用開始日"
                    value={enterpriseStartDate}
                    onChange={date =>
                      handleTimeChange(
                        'enterpriseStartDate', date,
                      )}
                    ref={(ref) => {
                      if (ref) {
                        this.refsToValidate.push(ref);
                      }
                    }}
                    disabled={isEnterpriseNotChild || isEditSameEnterprise} // STEP13.0.0 TAS-21617
                  />
                </Col>
              </Form.Group>
            )}
            <Field
              label="汎用請求番号"
              name="generalPurposeNumber"
              component={ValidationField}
              // sprint_20230403 #2 START
              maxLength="16"
              // sprint_20230403 #2 END
              validate={[validators.generalPurposeNumber]}
              clearTouch={() => {
                this.props.untouch('generalPurposeNumber');
              }}
              hidden={isEnterpriseNotChild || isEditSameEnterprise} // STEP13.0.0 TAS-21617
            />
          </>
        )}
        {/* sprint_20230403 #4 END */}

        {/* Step 12.0.0 TAS-18710 START */}
        {isEnterpriseNotChild && (
          <Field
            type="select"
            options={SELECT_BOX_DATA.DORMANT_STATE}
            label="稼働状態"
            name="dormantState"
            inputSize={3}
            component={ValidationField}
            labelSize={4}
            normalize={normalize}
            disabled
          />
        )}
        {/* Step 12.0.0TAS-18710 END */}

        <Category label="利用機能設定" />

        <Field
          indent={1}
          type="select"
          options={SELECT_BOX_DATA.AVAILABLE_DISABLE_USAGE}
          label="ビデオ"
          labelSecond="利用有無"
          name="usageSettingInfo.usageSettingVideo"
          parse={value => (value ? parseInt(value, 10) : '')}
          onChange={this.handleOptionChange}
          component={ValidationField}
          disabled={isEditLoggedInEnterprise || isEnterpriseNotChild || isEditSameEnterprise} // STEP13.0.0 TAS-21617
        />
        {isSupperUserL0 && (
          <>
            {/* #7182 START */}
            {isDisableUpdateUnitPrice ? (
              <Form.Group className="form-info">
                <Col sm={12} as={Form.Label} >
                  <Col sm={3} className={isSettingPricePlanUpdateReservedFlag ? "bold form-label padding-left-clear" : 'bold padding-left-clear'}>
                    単価設定
                  </Col>
                  {isUsingNewPlan && (
                    <Col
                      sm={{
                        span: 8,
                        offset: 1
                      }}
                      className="textColorRed padding-left-clear">
                      <p className="padding-left-10">表示されている単価設定は変更できません。</p>
                    </Col>
                  )}
                  {isSettingPricePlanUpdateReservedFlag && (
                    <Col
                      sm={{
                        span: 8,
                        offset: 1
                      }}
                      className="textColorRed padding-left-clear">
                      <p className="text-center">新料金プラン（予約中）に表示されている単価設定は変更できません。</p>
                      <p className="text-center padding-top-5">表示されている単価は旧料金プラン時の設定です。</p> {/* #7199 */}
                    </Col>
                  )}
                </Col>
              </Form.Group>
             ) : <Category label="単価設定" /> }
            {/* #7182 END */}
            {!isShowNewPlanCombobox && isEnterpriseLayerL1 && isSettingPricePlanUpdateReservedFlag && (
              <Item name="料金プラン" value={NEW_PRICE_PLAN_RESERVATION} indent={1} labelSize={4} valueSize={8} />
             )}
            {!isShowNewPlanCombobox && isEnterpriseLayerL1 && orgPricePlan === PRICE_PLAN.NEW && (
              <Item name="料金プラン" value={SELECT_BOX_DATA.ENTERPRISE_PRICE_PLAN[0].name} indent={1} labelSize={4} valueSize={8} />
            )}
            {isShowNewPlanCombobox && isEnterpriseLayerL1 && (
              <Field
                indent={1}
                type="select"
                options={SELECT_BOX_DATA.ENTERPRISE_PRICE_PLAN}
                label="料金プラン"
                name="usageSettingInfo.pricePlan"
                inputSize={4}
                component={ValidationField}
                labelSize={4}
                normalize={normalize}
                onChange={this.handleOptionChange}
              />
            )}
            <Field
              indent={1}
              label="ID単価"
              name="unitPriceSettingInfo.unitPriceSettingId"
              type="text"
              afterAddon="円"
              component={ValidationField}
              inputSize={8}
              labelSize={4}
              validate={[this.validateSmallInt]}
              normalize={normalize}
              disabled={isDisableUpdateUnitPrice || isEditSameEnterprise} /* #7182 */ // STEP13.0.0 TAS-21617
            />

            {isShowUsageSetting && (usageSettingInfo.usageSettingDrill === USAGE_SETTING.USE ||
              usageSettingInfo.usageSettingDocument === USAGE_SETTING.USE ||
              usageSettingInfo.usageSettingLrs === USAGE_SETTING.USE) && (
              <Field
                indent={1}
                label="学習プランストレージ加算料"
                name="unitPriceSettingInfo.unitPriceSettingLmsStorage"
                type="text"
                afterAddon="円"
                component={ValidationField}
                inputSize={8}
                labelSize={4}
                validate={[this.validateSmallInt]}
                normalize={normalize}
                disabled={isDisableUpdateUnitPrice || isEditSameEnterprise} /* #7182 */ // STEP13.0.0 TAS-21617
              />
            )}

            {isShowUsageSetting && usageSettingInfo.usageSettingVideo === USAGE_SETTING.USE && (
              <Field
                indent={1}
                label="ビデオストレージ加算料"
                name="unitPriceSettingInfo.unitPriceSettingVideoStorage"
                type="text"
                afterAddon="円"
                component={ValidationField}
                inputSize={8}
                labelSize={4}
                validate={[this.validateSmallInt]}
                normalize={normalize}
                disabled={isDisableUpdateUnitPrice || isEditSameEnterprise} /* #7182 */ // STEP13.0.0 TAS-21617
              />
            )}

            {isShowUsageSetting && usageSettingInfo.usageSettingVideo === USAGE_SETTING.USE && (
              <Field
                indent={1}
                label="ビデオオプション利用料"
                name="unitPriceSettingInfo.unitPriceSettingVideoFlowRate"
                type="text"
                afterAddon="円"
                component={ValidationField}
                inputSize={8}
                labelSize={4}
                validate={[this.validateSmallInt]}
                normalize={normalize}
                disabled={isDisableUpdateUnitPrice || isEditSameEnterprise} /* #7182 */ // STEP13.0.0 TAS-21617
              />
            )}
          </>
        )}

        <Field
          type="select"
          options={SELECT_BOX_DATA.DORMANT_STATE}
          label="稼働状態"
          name="dormantState"
          inputSize={3}
          component={ValidationField}
          labelSize={4}
          normalize={normalize}
          disabled={isEditLoggedInEnterprise || isEditSameEnterprise} // STEP13.0.0 TAS-21617
          hidden={isEnterpriseNotChild}
        />

        {/* sprint_20230403 #4 START */}
        {/* Step 10.0.0 START */}
        {editMode && isShowContractorInfo && (
          <>
            {/* display for both L0 and root_user */}
            <Category label="契約者情報" />
            <Field
              indent={1}
              label="契約事業者名"
              name="subscriberName"
              type="text"
              component={ValidationField}
              inputSize={7}
              labelSize={5}
              disabled={isEditLoggedInEnterprise || isEditSameEnterprise || isEnterpriseNotChild} // STEP13.0.0 TAS-21617
            />
            <Field
              indent={1}
              label="契約事業者の担当者名"
              name="subscriberContactPersonName"
              type="text"
              component={ValidationField}
              inputSize={7}
              labelSize={5}
              disabled={isEditLoggedInEnterprise || isEditSameEnterprise || isEnterpriseNotChild} // STEP13.0.0 TAS-21617
            />
            <Field
              indent={1}
              label="契約事業者の電話番号"
              name="subscriberPhoneNumber"
              type="text"
              component={ValidationField}
              inputSize={7}
              labelSize={5}
              validate={[validators.phoneNumber]}
              disabled={isEditLoggedInEnterprise || isEditSameEnterprise || isEnterpriseNotChild} // STEP13.0.0 TAS-21617
            />
            <Field
              indent={1}
              label="契約事業者のメールアドレス"
              name="subscriberEmailAddress"
              type="text"
              component={ValidationField}
              inputSize={7}
              labelSize={5}
              validate={[validators.emailAddress]}
              disabled={isEditLoggedInEnterprise || isEditSameEnterprise || isEnterpriseNotChild} // STEP13.0.0 TAS-21617
            />
            <Field
              indent={1}
              label="システム情報連絡先担当者名1"
              name="systemInfomationContactPersonName1"
              type="text"
              component={ValidationField}
              inputSize={7}
              labelSize={5}
              disabled={isEditLoggedInEnterprise || isEditSameEnterprise || isEnterpriseNotChild} // STEP13.0.0 TAS-21617
            />
            <Field
              indent={1}
              label="システム情報連絡先担当者名2"
              name="systemInfomationContactPersonName2"
              type="text"
              component={ValidationField}
              inputSize={7}
              labelSize={5}
              disabled={isEditLoggedInEnterprise || isEditSameEnterprise || isEnterpriseNotChild} // STEP13.0.0 TAS-21617
            />
            <Field
              indent={1}
              label="システム情報連絡先担当者名3"
              name="systemInfomationContactPersonName3"
              type="text"
              component={ValidationField}
              inputSize={7}
              labelSize={5}
              disabled={isEditLoggedInEnterprise || isEditSameEnterprise || isEnterpriseNotChild} // STEP13.0.0 TAS-21617
            />
            <Field
              indent={1}
              label="システム情報連絡先メールアドレス1"
              name="systemInfomationContactEmailAddress1"
              type="text"
              component={ValidationField}
              inputSize={7}
              labelSize={5}
              validate={[validators.emailAddress]}
              disabled={isEditLoggedInEnterprise || isEditSameEnterprise || isEnterpriseNotChild} // STEP13.0.0 TAS-21617
            />
            <Field
              indent={1}
              label="システム情報連絡先メールアドレス2"
              name="systemInfomationContactEmailAddress2"
              type="text"
              component={ValidationField}
              inputSize={7}
              labelSize={5}
              validate={[validators.emailAddress]}
              disabled={isEditLoggedInEnterprise || isEditSameEnterprise || isEnterpriseNotChild} // STEP13.0.0 TAS-21617
            />
            <Field
              indent={1}
              label="システム情報連絡先メールアドレス3"
              name="systemInfomationContactEmailAddress3"
              type="text"
              component={ValidationField}
              inputSize={7}
              labelSize={5}
              validate={[validators.emailAddress]}
              disabled={isEditLoggedInEnterprise || isEditSameEnterprise || isEnterpriseNotChild} // STEP13.0.0 TAS-21617
            />
          </>
        )}
        {/* Step 10.0.0 END */}

        {/* sprint_20230403 #4 START */}
        {/* display for L0 only */}
        {editMode && isSupperUserL0 && (
          <>
            <Field
              indent={1}
              label="お客様ID"
              name="customerId"
              type="text"
              component={ValidationField}
              inputSize={7}
              labelSize={5}
              disabled={isEditSameEnterprise} // STEP13.0.0 TAS-21617
            />
            <Field
              indent={1}
              label="担当者社員コード"
              name="contactPersonEmployeeCode"
              type="text"
              component={ValidationField}
              inputSize={7}
              labelSize={5}
              disabled={isEditSameEnterprise} // STEP13.0.0 TAS-21617
            />

            <Field
              indent={1}
              label="担当者社員名"
              name="contactPersonName"
              type="text"
              component={ValidationField}
              inputSize={7}
              labelSize={5}
              disabled={isEditSameEnterprise} // STEP13.0.0 TAS-21617
            />
            <Field
              indent={1}
              label="事業部名"
              name="divisionName"
              type="text"
              component={ValidationField}
              inputSize={7}
              labelSize={5}
              disabled={isEditSameEnterprise} // STEP13.0.0 TAS-21617
            />
            <Field
              indent={1}
              label="事業所名"
              name="officeName"
              type="text"
              component={ValidationField}
              inputSize={7}
              labelSize={5}
              disabled={isEditSameEnterprise} // STEP13.0.0 TAS-21617
            />
            <Field
              indent={1}
              label="部課名"
              name="departmentName"
              type="text"
              component={ValidationField}
              inputSize={7}
              labelSize={5}
              disabled={isEditSameEnterprise} // STEP13.0.0 TAS-21617
            />
            <Field
              indent={1}
              label="契約種別"
              name="contractCategory"
              type="text"
              component={ValidationField}
              inputSize={7}
              labelSize={5}
              disabled={isEditSameEnterprise} // STEP13.0.0 TAS-21617
            />
            {/* sprint_20230731_tma START */}
            <Field
              indent={1}
              label="販売部門コード"
              name="saleCd"
              type="text"
              component={ValidationField}
              validate={[validators.saleCd]}
              inputSize={7}
              labelSize={5}
              disabled={isEditSameEnterprise} // STEP13.0.0 TAS-21617
            />
            {/* sprint_20230731_tma END */}
            <Field
              indent={1}
              label="チャネル区分"
              name="channelDivision"
              type="text"
              component={ValidationField}
              inputSize={7}
              labelSize={5}
              disabled={isEditSameEnterprise} // STEP13.0.0 TAS-21617
            />
            <Field
              indent={1}
              label="販売区分"
              name="saleDivision"
              type="text"
              component={ValidationField}
              inputSize={7}
              labelSize={5}
              disabled={isEditSameEnterprise} // STEP13.0.0 TAS-21617
            />
            <Field
              indent={1}
              label="備考/変更履歴"
              name="enterpriseRemark"
              type="text"
              component={ValidationField}
              inputSize={7}
              labelSize={5}
              disabled={isEditSameEnterprise} // STEP13.0.0 TAS-21617
            />
            <Item name="解約フラグ" value={getEnterpriseDeleteFlagLabel(enterpriseDeleteFlag)} indent={1} labelSize={5} valueSize={7} />
            <Item name="解約予定日" value={utils.parseDateForDetail(editingEnterprise.enterpriseDeleteDate, DEFAULT_DATE_FORMAT)} indent={1} labelSize={5} valueSize={7} />
            <Field
              indent={1}
              type="select"
              options={SELECT_BOX_DATA.AVAILABLE_DISABLE_USAGE_BOOLEAN_VALUE}
              label="IPアドレス制限利用"
              name="ipRestriction"
              component={ValidationField}
              inputSize={7}
              labelSize={5}
              parse={(value) => value === 'true'}
              onChange={this.handleOptionChange}
              disabled={isEditSameEnterprise} // STEP13.0.0 TAS-21617
            />
            <Item name="請求対象システム" value={getBillingSystemTargetLabel(billingSystemTarget)} indent={1} labelSize={5} valueSize={7} />
            {/* sprint_20230508_tma #20 START */}
            <Field
              indent={1}
              label="与信審査"
              name="creditCheckedFlag"
              type="select"
              options={SELECT_BOX_DATA.CREDIT_CHECKED_FLAG}
              component={ValidationField}
              inputSize={7}
              labelSize={5}
              parse={value => (value ? parseInt(value, 10) : '')}
              onChange={this.handleOptionChange}
              disabled={isEditSameEnterprise} // STEP13.0.0 TAS-21617
            />
            {/* sprint_20230508_tma #20 END */}
            <Item name="請求情報登録ステータス" value={getBillingSystemRegisterFlagLabel(billingSystemRegisterFlag)} indent={1} labelSize={5} valueSize={7} />
            <Field
              indent={1}
              label="スマートスタディサービス利用停止フラグ"
              name="serviceStopFlag"
              type="select"
              options={SELECT_BOX_DATA.SERVICE_STOP_FLAG}
              component={ValidationField}
              inputSize={7}
              labelSize={5}
              parse={(value) => value === 'true'}
              onChange={this.handleOptionChange}
              disabled={isEditSameEnterprise} // STEP13.0.0 TAS-21617
            />
            {/*  sprint_20230605_tma START */}
            <Field
              indent={1}
              label="支払い種別"
              name="paymentType"
              type="select"
              options={SELECT_BOX_DATA.PAYMENT_TYPE}
              component={ValidationField}
              inputSize={7}
              labelSize={5}
              parse={value => (value ? parseInt(value, 10) : '')}
              onChange={this.handleOptionChange}
              disabled={isEditSameEnterprise} // STEP13.0.0 TAS-21617
            />
            {/* sprint_20230605_tma END */}
          </>
        )}
        {/* sprint_20230403 #4 END */}
        {/* STEP12.0.0 TAS-18710 START  */}
        {editMode && rootFlag && (
          <Field
            indent={1}
            label="パスワード手動変更"
            name="manualPasswordSettingFlag"
            type="select"
            options={SELECT_BOX_DATA.MANUAL_PASSWORD_SETTING_FLAG}
            component={ValidationField}
            inputSize={7}
            labelSize={5}
            parse={(value) => value === 'true'}
            onChange={this.handleOptionChange}
          />
        )}
        {/* STEP12.0.0 TAS-18710 END  */}
        {/* sprint_20230522_tma START */}
        <DialogConfirm
          showModal={this.state.showCreditCheck}
          content={MSG_CREDIT_CHECK_ENTERPRISE}
          onOK={() => this.setState({ showCreditCheck: false })}
          animation={false}
        />
        {/* sprint_20230522_tma END */}
        {/* STEP12.0.0 TAS-18710 START */}
        <DialogConfirm
          showModal={this.state.showManualPasswordSettingModal}
          content={MSG_MANUAL_PASSWORD_SETTING_FLAG_CONTENT}
          onOK={() => this.setState({ showManualPasswordSettingModal: false })}
          onCancel={this.onCancelManualPasswordDialog}
          animation={false}
          title={MSG_MANUAL_PASSWORD_SETTING_FLAG_TITLE}
          leftContent
        />
        {/* STEP12.0.0 TAS-18710 END */}
        <input type="submit" hidden="true" />
      </Form>
    );
  }
}

function normalize(value) {
  const test = parseInt(value, 10);
  if (!isNaN(test)) {
    return test;
  }
  return value;
}

const EnterpriseEditForm = reduxForm({
  form: 'enterpriseEditForm',
  enableReinitialize: true,
  onSubmit: submit,
  touchOnChange: false,
  touchOnBlur: true,
})(EnterpriseEdit);

const mapStateToProps = (state, ownProps) => {
  const { editingEnterprise, orgPricePlan } = state.enterprise;
  const { userInfo, rootFlag, enterpriseCd } = state.authed.authedUser;
  return {
    initialValues: editingEnterprise,
    editingEnterprise,
    orgPricePlan,
    userInfo,
    rootFlag,
    enterpriseCdLogin: enterpriseCd,
  };
};
export default connect(mapStateToProps)(EnterpriseEditForm);
